<template>
  <div class="fale-conosco" v-click-fora="fechar">
    <button
      type="button"
      class="fale-conosco__btn"
      :aria-expanded="aberto ? 'true' : 'false'"
      aria-haspopup="true"
      @click="alternar"
    >
      <i class="bi bi-whatsapp"></i> Fale conosco
    </button>

    <!-- Dois canais comerciais distintos: o usuário escolhe (spec §11). -->
    <ul class="fale-conosco__menu" v-show="aberto">
      <li class="fale-conosco__titulo">Falar com o Comercial</li>
      <li v-for="w in numeros" :key="w.numero">
        <a
          :href="link(w.numero)"
          target="_blank"
          rel="noopener"
          @click="onEscolher(w)"
        >
          <i class="bi bi-whatsapp"></i>
          <span>{{ w.display }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { WHATSAPPS_COMERCIAL, whatsappUrl } from '../services/contato';
import { analytics } from '../services/analyticsService';

export default {
  name: 'BotaoFaleConosco',
  directives: {
    // Fecha o menu ao clicar fora dele.
    clickFora: {
      mounted(el, binding) {
        el.__cliqueFora = (e) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener('click', el.__cliqueFora);
      },
      unmounted(el) {
        document.removeEventListener('click', el.__cliqueFora);
      },
    },
  },
  data() {
    return { aberto: false, numeros: WHATSAPPS_COMERCIAL };
  },
  methods: {
    alternar() {
      this.aberto = !this.aberto;
      if (this.aberto) analytics.ctaComercialClick('header_whatsapp');
    },
    fechar() {
      this.aberto = false;
    },
    link(numero) {
      return whatsappUrl(numero);
    },
    onEscolher(w) {
      analytics.ctaComercialClick(`header_whatsapp_${w.ddd}`);
      this.aberto = false;
    },
  },
};
</script>

<style scoped>
.fale-conosco {
  position: relative;
  display: inline-block;
  margin: 10px 0 15px;
}

/* Espelha o box model do "Acessar o sistema" vizinho para os dois botões
   ficarem da MESMA altura: aquele herda border 2px da regra .btn do
   HeaderSlide e usa display block com padding 9px, não flex. */
.fale-conosco__btn {
  font-family: poppins, sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  background: #25d366;
  padding: 9px 16px;
  white-space: nowrap;
  border-radius: 8px;
  border: 2px solid #25d366;
  cursor: pointer;
  display: block;
  text-align: center;
  transition: background 0.2s ease;
}
.fale-conosco__btn i {
  vertical-align: middle;
  margin-right: 6px;
}
.fale-conosco__btn:hover {
  background: #1ebe5d;
  border-color: #1ebe5d;
}

.fale-conosco__menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1000;
  min-width: 220px;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
}

.fale-conosco__titulo {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #999;
  padding: 4px 16px 8px;
}

.fale-conosco__menu a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  font-size: 14px;
  color: #191919;
  text-decoration: none;
  white-space: nowrap;
}
.fale-conosco__menu a:hover {
  background: #f4f4f4;
  color: #25d366;
}
.fale-conosco__menu a i {
  color: #25d366;
  font-size: 16px;
}

/* No mobile o menu abre alinhado à esquerda para não sair da tela. */
@media (max-width: 991px) {
  .fale-conosco {
    display: block;
  }
  .fale-conosco__btn {
    width: 100%;
    justify-content: center;
  }
  .fale-conosco__menu {
    right: auto;
    left: 0;
    width: 100%;
  }
}
</style>
